/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit';

import {
 commonReducers,
 CommonState,
 initialCommonState,
} from '../_common/commonReducers';

interface VehiclesState extends CommonState {}

const initialState: VehiclesState = {
 ...initialCommonState,
};

const vehiclesSlice = createSlice({
 name: 'vehicles',
 initialState,
 reducers: commonReducers,
});

export const {
 getTableStart,
 getTableSuccess,
 getTableFailure,
 getTableFinish,

 getItemStart,
 getItemSuccess,
 getItemFailure,

 createItemStart,
 createItemSuccess,
 createItemFailure,
 createItemFinish,

 updateItemStart,
 updateItemSuccess,
 updateItemFailure,
 updateItemFinish,

 deleteItemStart,
 deleteItemSuccess,
 deleteItemFailure,
 deleteItemFinish,

 getTableStructureStart,
 getTableStructureSuccess,
 getTableStructureFailure,

 getItemDocumentsStart,
 getItemDocumentsSuccess,
 getItemDocumentsFailure,

 uploadItemDocumentsStart,
 uploadItemDocumentsSuccess,
 uploadItemDocumentsFailure,
 uploadItemDocumentsFinish,

 deleteItemDocumentStart,
 deleteItemDocumentSuccess,
 deleteItemDocumentFailure,
 deleteItemDocumentFinish,

 getTableExcelStart,
 getTableExcelSuccess,
 getTableExcelFailure,
 getTableExcelFinish,
} = vehiclesSlice.actions;
export default vehiclesSlice;
